import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  GraduationCap,
  Check,
  CheckCircle,
  X,
  XCircle,
  Clock,
  AlertTriangle,
  UserX,
  ArrowLeftRight,
  LogOut,
  Plane,
  Minus,
  Trash2,
  FileText,
  FastForward,
  ChevronsUp,
  Loader2,
  HelpCircle,
  NotebookPen
} from 'lucide-angular';

import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { LazyLoadDirective } from './directives/lazy-load.directive';
import { LabelSituacaoMatriculaComponent } from './components/label-situacao-matricula/label-situacao-matricula.component';

/**
 * SharedModule — módulo de componentes reutilizáveis em toda a aplicação.
 * Importe nos módulos de features que precisem usar app-empty-state (e futuros
 * componentes compartilhados).
 */
@NgModule({
  declarations: [
    EmptyStateComponent,
    LazyLoadDirective,
    LabelSituacaoMatriculaComponent
  ],
  imports: [
    CommonModule,
    LucideAngularModule.pick({
      GraduationCap,
      Check,
      CheckCircle,
      X,
      XCircle,
      Clock,
      AlertTriangle,
      UserX,
      ArrowLeftRight,
      LogOut,
      Plane,
      Minus,
      Trash2,
      FileText,
      FastForward,
      ChevronsUp,
      Loader2,
      HelpCircle,
      NotebookPen
    })
  ],
  exports: [
    EmptyStateComponent,
    LazyLoadDirective,
    LabelSituacaoMatriculaComponent
  ]
})
export class SharedModule {}
